import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ComingSoonPage = () => {
    return (
        <div className="bg-black min-h-screen w-full font-mono text-white flex flex-col justify-center items-center relative overflow-hidden">
            {/* Background */}
            <div className="absolute inset-0 opacity-20 bg-gradient-to-br from-purple-900 via-transparent to-blue-900"></div>

            <div className="relative z-10 text-center px-8 py-12">
                {/* Navigation */}
                <div className="mb-12">
                    <Link
                        to="/"
                        className="inline-flex items-center space-x-2 text-sm hover:opacity-70 transition-opacity"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        <span>Back to Projects</span>
                    </Link>
                </div>

                {/* Heading */}
                <h1 className="text-6xl font-bold mb-4 bg-gradient-to-r from-blue-400 via-purple-400 to-blue-400 bg-clip-text text-transparent">
                    Coming Soon
                </h1>
                <p className="text-xl max-w-2xl mx-auto text-gray-300">
                    This page is still in the works. Stay tuned as we push the boundaries of creativity and technology.
                </p>

                {/* Placeholder Image */}
                <div className="mt-12">
                    <img
                        src="/exit-death.png"  // Correct path when placed in public folder
                        alt="Placeholder"
                        className="w-full max-w-md mx-auto rounded-lg"
                    />
                </div>

                {/* Footer */}
                <footer className="text-center text-gray-500 mt-12">
                    © Exit Death. Redefining the boundaries of existence.
                </footer>
            </div>
        </div>
    );
};

export default ComingSoonPage;
